import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContentBlock } from '../blocks/ContentBlocks/ContentBlocks';
import { useDispatch } from 'react-redux';
import { showErrorPage } from '../../../redux/slices/coreSlice';
import { useEffectSkipInitialRender } from '../../../hooks/useEffectSkipInitialRender.jsx';

const HttpErrorBase = ({
  showTitle = true,
  showShadow = true,
  title,
  statusCode,
  description,
  message,
  inCMS,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  // Disable error page on route change
  useEffectSkipInitialRender(() => {
    dispatch(showErrorPage(undefined));
  }, [location, dispatch]);

  return (
    <div className="custom-page-dynamic-container">
      <ContentBlock
        title={showTitle ? title : undefined}
        contentWrapper="content-wrapper"
        shadow={showShadow}
        contentVisible
      >
        <h1 className="error-status-code">{statusCode}</h1>
        {message ? <p className="error-message">{message}</p> : null}
        <p className="error-description">
          {description} {inCMS ? '' : t('Skúste nasledovné možnosti:')}
        </p>
        <div style={{ textAlign: 'center' }}>
          {statusCode === 404 && !inCMS ? (
            <ul style={{ display: 'inline-block', paddingLeft: '15px' }}>
              <li style={{ textAlign: 'left' }}>
                {t('skontrolujte, či adresa v prehliadači je zadaná správne')}
              </li>
              <li style={{ textAlign: 'left' }}>
                {t('skúste sa na požadovanú stránku dostať z')}{' '}
                <a href={window.location.origin}>{t('domovskej stránky')}</a>
              </li>
            </ul>
          ) : null}
        </div>
      </ContentBlock>
    </div>
  );
};

export function HttpError({
  showTitle = true,
  showShadow = true,
  statusCode,
  message = '',
  inCMS = false,
}) {
  const { t } = useTranslation();

  if (statusCode === 403) {
    return (
      <HttpErrorBase
        showTitle={showTitle}
        showShadow={showShadow}
        title={t('NEPOVOLENÝ PRÍSTUP')}
        description={t(
          'Na prístup k tomuto zdroju nemáte dostatočné oprávnenia.',
        )}
        statusCode={statusCode}
        message={message}
        inCMS={inCMS}
      />
    );
  }

  if (statusCode === 404) {
    return (
      <HttpErrorBase
        showTitle={showTitle}
        showShadow={showShadow}
        title={t('STRÁNKA NEBOLA NÁJDENÁ')}
        description={t('Bohužiaľ, požadovaná stránka alebo súbor sa nenašiel.')}
        statusCode={statusCode}
        message={message}
        inCMS={inCMS}
      />
    );
  }

  return null;
}
